import { Directive, HostListener, output, signal } from '@angular/core';

@Directive({
  selector: '[appDnd]',
  host: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '[class.fileOver]': 'fileOver()',
  },
})
export class DndDirective {
  fileOver = signal(false);
  fileDropped = output<FileList>();

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver.set(true);
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver.set(false);
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver.set(false);
    const files = evt.dataTransfer?.files;
    if (files && files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
